import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgExclamationFilled16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67085 0.414578C8.39445 -0.138193 7.60561 -0.138192 7.32922 0.414578L0.0801534 14.9121C-0.169196 15.4107 0.193425 15.9975 0.750967 15.9975H15.2491C15.8066 15.9975 16.1693 15.4107 15.9199 14.9121L8.67085 0.414578ZM8.68472 9.77623C8.68472 10.0524 8.46086 10.2762 8.18472 10.2762H7.84455C7.56841 10.2762 7.34455 10.0524 7.34455 9.77623V6.93163C7.34455 6.65549 7.56841 6.43163 7.84455 6.43163H8.18472C8.46086 6.43163 8.68472 6.65549 8.68472 6.93163V9.77623ZM8.00068 11.7852C8.21473 11.7852 8.39156 11.8368 8.53116 11.9399C8.67076 12.0431 8.74056 12.2072 8.74056 12.4323C8.74056 12.6856 8.67076 12.8544 8.53116 12.9388C8.39156 13.0326 8.21473 13.0795 8.00068 13.0795C7.81454 13.0795 7.65167 13.0326 7.51207 12.9388C7.36316 12.8544 7.28871 12.6856 7.28871 12.4323C7.28871 12.1979 7.36316 12.029 7.51207 11.9259C7.65167 11.8321 7.81454 11.7852 8.00068 11.7852Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationFilled16);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=ExclamationFilled16.svg.js.map
